// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"73809609","283":"bea07dff","395":"c4013ca3","426":"5bac9722"}[chunkId] + ".chunk.js";
};